(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["taprevoo-product"] && !Shopify.designMode) return;
  try {
    const initialiseTapRevooGalleries = (root = document) => {
  root.querySelectorAll('.trp-gallery').forEach((gallery) => {
    if (gallery.dataset.dotsReady === 'true') return;

    const track = gallery.querySelector('.trp-gallery-track');
    const dots = Array.from(
      gallery.querySelectorAll('.trp-gallery-dots a')
    );

    if (!track || dots.length === 0) return;

    let frame;

    const updateDots = () => {
      const index = track.clientWidth
        ? Math.round(track.scrollLeft / track.clientWidth)
        : 0;

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);

        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(updateDots);
      },
      { passive: true }
    );

    gallery.dataset.dotsReady = 'true';
    updateDots();
  });
};

initialiseTapRevooGalleries();

document.addEventListener('shopify:section:load', (event) => {
  initialiseTapRevooGalleries(event.target);
});
  } catch(e) { console.error(e); }
})();

})();
